export const stikiStaticColors = {
  khaki: '#F0E68C',
  darkKhaki: '#BDB76B',
  pink: 'rgb(255, 168,  207)',
  darkPink: 'rgb(255, 84, 207)',
  yellow: 'rgb(255, 255, 150)',
  darkYellow: 'rgb(255, 255, 100)',
  blue: 'rgb(168, 207, 255)',
  darkBlue: 'rgb(84, 207, 255)',
  green: 'rgb(161, 255, 181)',
  darkGreen: 'rgb(6, 255, 102)',
}

export const welcomeStaticData = {
  isStatic: true,
  pages: [
    {
      page: {
        id: -1,
        user_id: -1,
        title: 'Welcome',
        left_edge: 3.5,
        top_edge: -2,
        zoom: 1.33,
        stikis: [
          {
            stiki: {
              id: -1,
              left_edge: -29,
              top_edge: -7.5,
              width: 15.0,
              height: 7.0,
              z_index: 0,
              color: stikiStaticColors.pink,
              text: 'Stikis are little notes that you can type in, move and color.',
              page_id: -1,
            },
          },
          {
            stiki: {
              id: -2,
              left_edge: -25,
              top_edge: 1,
              width: 15.0,
              height: 7.0,
              z_index: 1,
              color: stikiStaticColors.darkPink,
              text: 'Stikis are on the web, so you can access them from any computer',
              page_id: -1,
            },
          },
          {
            stiki: {
              id: -3,
              left_edge: -11,
              top_edge: -8.5,
              width: 11.0,
              height: 3.0,
              z_index: 2,
              color: stikiStaticColors.yellow,
              text: 'Things to do',
              page_id: -1,
            },
          },
          {
            stiki: {
              id: -4,
              left_edge: -9,
              top_edge: -4.5,
              width: 11,
              height: 3,
              z_index: 3,
              color: stikiStaticColors.darkYellow,
              text: 'Useful snippets.',
              page_id: -1,
            },
          },
          {
            stiki: {
              id: -5,
              left_edge: -7,
              top_edge: -0.5,
              width: 11,
              height: 3,
              z_index: 4,
              color: stikiStaticColors.darkYellow,
              text: 'Space for ideas.',
              page_id: -1,
            },
          },
          {
            stiki: {
              id: -6,
              left_edge: -5,
              top_edge: 3.5,
              width: 11,
              height: 3,
              z_index: 5,
              color: stikiStaticColors.yellow,
              text: "...It's up to you.",
              page_id: -1,
            },
          },
          {
            stiki: {
              id: -7,
              left_edge: 6,
              top_edge: -10,
              width: 15.0,
              height: 7.0,
              z_index: 6,
              color: stikiStaticColors.blue,
              text: 'Stikis are easy to use and work on all modern web browsers',
              page_id: -1,
            },
          },
          {
            stiki: {
              id: -8,
              left_edge: 10,
              top_edge: -1.5,
              width: 15.0,
              height: 7.0,
              z_index: 7,
              color: stikiStaticColors.darkBlue,
              text: 'Sign up for a free account and try it yourself.',
              page_id: -1,
            },
          },
        ],
      },
    },
  ],
  auth_token: null,
  user_id: '-1',
  flash: {
    notice: '',
    alert: '',
  },
}
